import { Controller } from "@hotwired/stimulus"

// Reveals a floating nav pill once the page is scrolled past a threshold near
// the top, and hides it again at the top. Pure show/hide behavior — the markup
// lives in the landing view; this only toggles state classes on the element.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 120 } }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const revealed = window.scrollY > this.thresholdValue
    if (revealed === this.revealed) return
    this.revealed = revealed
    this.element.classList.toggle("opacity-0", !revealed)
    this.element.classList.toggle("-translate-y-3", !revealed)
    this.element.classList.toggle("pointer-events-none", !revealed)
  }
}
